<section class="container-fluid intro" [class.brand-tr]="isTrBrand">
  <div id="snow"></div>
  <div class="row justify-content-center pb-5">
    <img
      src="../../assets/logos/logo-inprovider-2.png"
      [attr.alt]="brandName"
      class="imgSizes img-setting"
    />
    <img
      src="../../assets/logos/logo-inprovider-2-old.png"
      [attr.alt]="brandName"
      class="imgSizes img-sm"
    />
    <img
      src="../../assets/logos/logo-inprovider-movil.png"
      [attr.alt]="brandName"
      class="imgSizes img-none"
    />
  </div>
  <div class="row justify-content-center">
    <div class="col-xl-5 col-lg-5 col-md-6 col-sm-8 col-4 mb-1 intro-exterior">
      <div class="form-group text-center intro-interior">
        @for (btn of moduleVisible; track btn) {
          @if (btn.disabled ? true : btn.visible) {
            <app-centered-menu-btn
              [isdisabled]="btn.disabled"
              [btnClass]="'btn btn-float btn-blue-lines gap_fl_btn'"
              [btnName]="btn.alias"
              [btnIcon]="btn.iconClass || ('inp-btn inp-icon-'+ btn.name)"
              [btnLink]="btn.link">
            </app-centered-menu-btn>
          }
        }
      </div>
    </div>
  </div>
</section>
